import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586b6156"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "button",
  class: "certification-card"
}
const _hoisted_2 = { class: "certification-badge" }
const _hoisted_3 = { class: "card-header-bg border-0 d-flex items-center justify-content-center" }
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { class: "image-container" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card-body-wrapper" }
const _hoisted_8 = { class: "card-body-content" }
const _hoisted_9 = { class: "certification-name" }
const _hoisted_10 = { class: "certification-description" }
const _hoisted_11 = { class: "button-container" }
const _hoisted_12 = { class: "view-certification-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {name: 'certifications-detail', params: {id: _ctx.certification.id}}
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.getStatusBadgeClass())
          }, _toDisplayString(_ctx.getStatusLabel()), 3)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.certification.thumb_url,
                alt: _ctx.certification.name,
                class: "certification-image"
              }, null, 8, _hoisted_6)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.certification.name), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.certification.description), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.certification.list.view_certification`)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}